<div class="gradient-border" [class.disabled]="disabled"></div>
